module.exports = __webpack_public_path__ + "static/media/yorkshire-place-HOA.d68ba551.pdf";